import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
const ProtectedRoute = ({ children, requireInternal = false }) => {
    const { user, loading, error, loginWithRedirect } = useAuth();
    if (loading) {
        return (_jsx(Box, Object.assign({ sx: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
            } }, { children: _jsx(CircularProgress, {}) })));
    }
    if (error) {
        return (_jsxs(Box, Object.assign({ sx: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                gap: 2,
            } }, { children: [_jsx(Typography, Object.assign({ variant: "h6", color: "error" }, { children: "Authentication Error" })), _jsx(Typography, Object.assign({ variant: "body1" }, { children: error })), _jsx(Button, Object.assign({ variant: "contained", onClick: () => window.location.reload() }, { children: "Retry" }))] })));
    }
    if (!user) {
        return (_jsxs(Box, Object.assign({ sx: {
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "100vh",
                gap: 2,
            } }, { children: [_jsx(Typography, Object.assign({ variant: "h4" }, { children: "Welcome to BringOnBoard" })), _jsx(Typography, Object.assign({ variant: "body1" }, { children: "Please log in to access the candidate dashboard" })), _jsx(Button, Object.assign({ variant: "contained", size: "large", onClick: () => loginWithRedirect() }, { children: "Log In" }))] })));
    }
    if (requireInternal && user.type !== "internal") {
        return _jsx(Navigate, { to: "/search", replace: true });
    }
    return _jsx(_Fragment, { children: children });
};
export default ProtectedRoute;
